/* ═══ VÍDEO SÓ BAIXA QUANDO CHEGA NA TELA — [2026-08-18, tarde] ═════════════════════
   Uma peça só para qualquer seção: marque a tag com `data-espera` e ela
   carrega e toca quando entrar na tela, e pausa quando sair.

   🔴 O QUE ISTO CONSERTA, medido na home em 390 px, com janela de verdade:
     três vídeos ABAIXO DA DOBRA baixavam inteiros no carregamento — o da
     seção `destaque` a 4.557 px de rolagem e o do `best` a 6.520 px, oito
     telas para baixo. Somados, ~3 MB que a maioria das visitas nunca vê.

   🔑 `autoplay` NÃO É PREGUIÇOSO. O atributo manda o navegador buscar dado
     assim que pode, esteja o elemento onde estiver na página. Quem adia é
     `preload="none"` + dar o play na mão quando entra em cena. O `poster`
     segura a imagem enquanto isso — e as três seções já têm poster.

   ⚠️ SEM `IntersectionObserver`, TOCA IMEDIATAMENTE. Navegador que não tem o
     observador não pode ficar com a seção muda: perder 3 MB é melhor que
     perder o conteúdo. */
(function () {
  'use strict';
  var videos = [].slice.call(document.querySelectorAll('video[data-espera]'));
  if (!videos.length) return;

  function liga(v) {
    /* 🪤 FONTE POR TAMANHO DE TELA. Quem tem `data-sd`/`data-hd` recebe o
       endereço só na hora de tocar — um telefone de 390 px não ganha nada com
       1920 de fonte e paga o triplo de dados por ela. Medido: a página
       Material foi de 16,8 MB para bem menos só com isto. */
    if (!v.src && !v.querySelector('source') && v.getAttribute('data-hd')) {
      var estreito = window.matchMedia('(max-width: 899px)').matches;
      v.src = (estreito ? v.getAttribute('data-sd') : v.getAttribute('data-hd')) || v.getAttribute('data-hd');
    }
    /* 🔴 O FILME NÃO COMEÇA ANTES DO PÔSTER TERMINAR — [2026-09-01].
       O vídeo do banner já está na primeira tela, então o observador dispara
       na hora e o play punha `preload="auto"` aos ~3,3 s. Só que o PÔSTER
       ainda estava descendo: 42 KB que levavam 9,4 s para chegar, porque os
       900 KB do filme comiam a banda no meio do caminho. Medido no Lighthouse:
         dia-estreito-poster.webp  42 KB · começa 1.479 ms · TERMINA 10.850 ms
         dia-estreito.mp4         900 KB · começa 3.358 ms
       Com o pôster chegando aos 10,8 s, o LCP da home ia a 10,9 s — e oscilava
       entre 3,5 e 10,9 conforme a banda liberasse.
       👉 Agora o play espera o pôster. Ele pinta cedo, vira o LCP (que é o que
         a pessoa vê primeiro de qualquer jeito), e o filme desce depois, sem
         disputa. 🪤 A imagem é a MESMA do atributo `poster`: o navegador reusa
         o download, não baixa duas vezes. */
    var toca = function () {
      if (v.preload !== 'auto') v.preload = 'auto';
      if (v.paused) { var t = v.play(); if (t && t.catch) t.catch(function () {}); }
    };
    /* 🔴 [2026-09-09] O PÔSTER TAMBÉM PRECISAVA ESPERAR. O atributo `poster` é
       baixado pelo navegador ASSIM QUE O HTML CHEGA, mesmo com `preload="none"`
       — `preload` vale para o filme, não para o cartaz. Medido na home em 4G
       lento: os pôsteres do `best` (51 KB) e do `destaque` (17 KB), que ficam
       oito telas abaixo, começavam aos 2,28 s e disputavam banda com a imagem
       que É o LCP da página, ainda descendo aos 7,4 s.
       👉 Agora eles nascem em `data-poster` e só viram `poster` aqui dentro,
         quando o observador dispara — 200px antes de a seção entrar. */
    if (!v.getAttribute('poster') && v.getAttribute('data-poster')) {
      v.setAttribute('poster', v.getAttribute('data-poster'));
    }
    var cartaz = v.getAttribute('poster');
    if (cartaz && !v.dataset.cartazPronto) {
      v.dataset.cartazPronto = '1';
      var im = new Image();
      im.onload = im.onerror = toca;
      im.src = cartaz;
      /* 🪤 rede ruim não pode deixar o filme parado para sempre — mas 4 s era
         CEDO DEMAIS e anulava a espera: medido, o pôster levava 9,4 s para
         chegar quando o filme disputava a banda, então o `setTimeout` soltava
         o filme antes e nada mudava. 9 s deixa o pôster ganhar em rede ruim e
         não muda nada em rede boa, onde ele chega em milissegundos. */
      setTimeout(toca, 9000);
      return;
    }
    toca();
  }

  if (!window.IntersectionObserver) { videos.forEach(liga); return; }

  var obs = new IntersectionObserver(function (linhas) {
    linhas.forEach(function (l) {
      if (l.isIntersecting) liga(l.target);
      else if (!l.target.paused) l.target.pause();   /* fora da tela, economiza bateria */
    });
  }, { threshold: 0.2, rootMargin: '200px 0px' });   /* 200px de antecedência: dá tempo
                                                        de o primeiro quadro chegar antes
                                                        de a seção entrar de fato */
  videos.forEach(function (v) { obs.observe(v); });
})();
